module.exports = __webpack_public_path__ + "static/media/cockroach(11).2e2f1294.PNG";